import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import LoginForm from './LoginForm'
import useAuthStore from '@/store/useAuthStore'
import VerifyEmailWithTargetUrl from './VerifyEmailWithTargetUrl'

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const target = searchParams.get('target')
  const login = searchParams.get('login')

  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  async function onSuccess() {
    // No need as isAuthenticated will automatically updated after successful login.
    // setCanVerify(true)
  }

  if (isAuthenticated || login === 'success') {
    return <VerifyEmailWithTargetUrl target={target} />
  }

  return (
    <div className="pf-auth grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>Sign in to verify your account</CardTitle>
        </CardHeader>
        <CardContent>
          <LoginForm onSuccess={() => onSuccess()} verifyEmail={false} />
        </CardContent>
      </Card>
    </div>
  )
}
